export default __webpack_public_path__ + "static/media/amendoim.e2019984.png";